<template>
  <section>
    <div
      v-if="!currentFormId"
      class="is-flex is-flex-direction-column is-align-items-center is-half-width mx-auto m-t-50"
      :data-e2e="DiagnosticToolCypressAttribute.views.LAUNCH_CARDS_DIV"
    >
      <h1 class="title is-size-1 has-text-weight-semibold">
        {{ $t('tools.diagnostic-tool-title') }}
      </h1>
      <div class="is-half-width has-text-centered">
        <h2>
          {{ $t('tools.diagnostic-tool-subtitle') }}
        </h2>
      </div>
      <div class="is-flex is-flex-direction-column m-t-10 column is-8">
        <template v-if="isLoading">
          <DiagnosticToolLaunchCardSkeleton />
          <DiagnosticToolLaunchCardSkeleton />
          <DiagnosticToolLaunchCardSkeleton />
        </template>
        <template v-else>
          <DiagnosticToolLaunchCard
            v-for="form in forms"
            :key="form.id"
            :title="form.title"
            :form-id="form.id"
            class="m-b-10"
            @show-form="onClick(form.id)"
          />
        </template>
      </div>
    </div>
    <TypeFormEmbedForm
      v-else
      :form-id="currentFormId"
      :is-in-modal="!!formId"
      @on-end-button-clicked="onEndButtonClicked"
    />
  </section>
</template>

<script>
import { DiagnosticToolCypressAttribute } from '@/modules/typeform/constants/DiagnosticToolCypressAttribute';
import { DiagnosticLaunchClickedEventTracking } from '@/modules/typeform/models/segmentevents/DiagnosticLaunchClickedEventTracking';
import DiagnosticToolLaunchCard from '@/modules/typeform/components/presentational/DiagnosticToolLaunchCard.vue';
import DiagnosticToolLaunchCardSkeleton from '@/modules/typeform/components/skeletons/DiagnosticToolLauchCardSkeleton.vue';
import TypeFormEmbedForm from '@/modules/typeform/components/stateful/TypeFormEmbedForm.vue';
import TypeformFormEntityService from '@/modules/typeform/services/TypeformFormEntityService';
import { ModalMixin } from '@/modules/core/ui/mixins/ModalMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DiagnosticToolLaunchView',
  emits: ['on-end-button-clicked'],
  mixins: [ModalMixin],
  components: {
    DiagnosticToolLaunchCardSkeleton,
    TypeFormEmbedForm,
    DiagnosticToolLaunchCard
  },
  props: {
    formId: {
      type: String
    }
  },
  static: {
    DiagnosticToolCypressAttribute
  },
  data() {
    return {
      currentFormId: null,
      forms: [],
      isLoading: true
    };
  },
  methods: {
    onClick(formId) {
      this.showForm(formId);
      DiagnosticLaunchClickedEventTracking.dispatch(formId);
    },
    showForm(formId) {
      this.currentFormId = formId;
    },
    async onInit() {
      this.isLoading = true;
      try {
        this.forms = await TypeformFormEntityService.getEntities();
      } finally {
        this.isLoading = false;
      }
    },
    onEndButtonClicked() {
      this.$emit('on-end-button-clicked');
      this.close();
    }
  },
  mounted() {
    if (this.formId) {
      this.showForm(this.formId);
    } else {
      this.onInit();
    }
  }
};
</script>
